import React from "react";
import { Sun, Moon } from "lucide-react";
import { useApp } from "@/context/AppContext";

export const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useApp();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggleTheme}
      data-testid="theme-toggle-button"
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-[var(--border-subtle)] text-[var(--text-primary)] transition-all duration-300 hover:border-[var(--accent-gold)] hover:text-[var(--accent-gold)] ${className}`}
    >
      <Sun className={`absolute h-[18px] w-[18px] transition-all duration-500 ${isDark ? "rotate-90 scale-0 opacity-0" : "rotate-0 scale-100 opacity-100"}`} />
      <Moon className={`absolute h-[18px] w-[18px] transition-all duration-500 ${isDark ? "rotate-0 scale-100 opacity-100" : "-rotate-90 scale-0 opacity-0"}`} />
    </button>
  );
};

export default ThemeToggle;
